import { DaperClient } from "@data/daper-client";
import { DaperStorySearchParams } from "@data/daper-client/types";

import { wrapResponse } from "./wrapResponse";

async function getDaperStoriesHandler(req, res) {
  // eslint-disable-next-line no-param-reassign
  res = wrapResponse(res);

  const params = req.query as DaperStorySearchParams;

  const primarySites = req.query.primarySites?.split(",") || [];
  const type = req.query.type?.split(",") || [];

  const daperClient = DaperClient.init({
    host: process.env.DAPER_URL,
    username: process.env.DAPER_USERNAME,
    password: process.env.DAPER_PASSWORD,
  });

  const daperResponse = await daperClient.getStoriesSearchBy({
    ...params,
    primarySites,
    type,
  });

  return res.status(200).json(daperResponse);
}

export default getDaperStoriesHandler;
